import React from "react";
import ReactEcharts from "echarts-for-react";

const MultipleBarGraph = ({ data, color,header }) => {
  const getOption = () => {
    const colors = [
      "#003EFF",
      "#FF8C00",
      "#00C49F",
      "#FFD700",
      "#9400D3",
      "#00CED1",
      "#FF1493",
    ];

    return {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: (params) => {
          let customContent = "";
          params?.forEach((param) => {
            const value = param.value === 0.1 ? 0 : param.value;
            const formattedValue =
              param.value === 0 ? "Custom Tooltip for 0" : value;
            const color = param.color;
            const tooltipItem = `
            <span 
            style="
            display: flex; 
            align-items: center; 
            padding:0;
            margin-bottom:-12px">
              <span 
              style="
                display: inline-block; <span 
                style="
                display: flex; 
                align-items: center; 
                padding
                width: 10px; 
                height: 10px; 
                border-radius: 50%; 
                background-color: ${color}; 
                margin-right: 5px;">
              </span>${param.seriesName}: ${formattedValue}
            </span><br/>`;
            customContent += tooltipItem;
          });
          return customContent;
        },
      },
      legend: {
        data: data.legend,
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "2%",
        top:"20%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: data.categories,
      },
      yAxis: {
        type: "value",
      },
      series: data.series.map((serie, index) => ({
        name: serie.name,
        type: "bar",
        data: serie.data.map((value) => ({
          value: value === 0 ? 0.1 : value,
          itemStyle: {
            opacity: value === 0 ? 0.3 : 1,
          },
        })),
        itemStyle: {
          color: color || colors[index % colors.length],
          barBorderRadius: [10, 10, 0, 0],
        },
        barMaxWidth: 10,
      })),
    };
  };

  return <>
  <div className="my-1 rounded text-center text-primary fs-1">{header||"Today"}</div>
  <ReactEcharts option={getOption()} />
  </>
};

export default MultipleBarGraph;
